import { render } from "./HelpRequestDetails.vue?vue&type=template&id=2ecbef4a"
import script from "./HelpRequestDetails.vue?vue&type=script&lang=js"
export * from "./HelpRequestDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__